import { Skeleton } from '@mui/material';
import { useGlobalContent } from 'hooks/useGlobalContent';
import useHandleCustomSchemeAndQuery from 'hooks/useHandleCustomSchemeAndQuery';
import { CardFragment as CardData, CardIntent } from 'generated/graphql';
import { ButtonCard } from './ButtonCard';
import ErrorReportingDialog from './ErrorReporting';
import IconCard from './IconCard';
import { MenuItemCard } from './MenuItemCard';

const CustomCard = ({
  data,
  isLoading,
  onRefresh = () => {},
  onFormRefresh = () => {},
  onClose = () => {},
  compact = false,
}: {
  data: CardData;
  isLoading: boolean;
  onRefresh?: () => void;
  onFormRefresh?: () => void;
  onClose?: () => void;
  compact?: boolean;
}) => {
  const intent = data.context;
  const { showContent } = useGlobalContent();

  const url = data.button.actions[0]?.url ?? '';
  const query = data.button.actions[0]?.query ?? '';
  const buttonValue = data.button.actions[0]?.value ?? '';
  const hideButton = url.length === 0 && query.length === 0 && buttonValue.length === 0;
  const opensFormDialog = url.startsWith('dialog:form');

  const handleMutate = () => {
    onRefresh();
    if (opensFormDialog) onFormRefresh();
  };

  const { handleSchemeOrQuery, isLoading: isActionLoading } = useHandleCustomSchemeAndQuery({ onMutate: handleMutate });

  const handleClick = () => {
    if (data?.button?.actions?.[0]?.code === 'report_error') {
      showContent(<ErrorReportingDialog />);
      onClose();
      return;
    }
    handleSchemeOrQuery(url, query);
  };

  return (
    <>
      {isLoading ? (
        <Skeleton height={100} variant="rectangular" sx={(theme) => ({ margin: theme.spacing(1) })} />
      ) : intent === CardIntent.IconCard ? (
        <IconCard data={data} onClick={handleClick} hideButton={hideButton} loading={isActionLoading} />
      ) : intent === CardIntent.Button ? (
        <ButtonCard data={data} onClick={handleClick} loading={isActionLoading} />
      ) : (
        <MenuItemCard data={data} onClick={handleClick} compact={compact} loading={isActionLoading} />
      )}
    </>
  );
};

export default CustomCard;
